import React from 'react';
import { useParams } from 'react-router-dom';
import CreateToolPage from '../components/ToolsSection/CreateToolModal';

const EditTool = () => {
  const { id } = useParams();
  return <CreateToolPage toolId={id} />;
};

export default EditTool;
